import { render, staticRenderFns } from "./BurningMatters.vue?vue&type=template&id=5d35f452&"
import script from "./BurningMatters.vue?vue&type=script&lang=js&"
export * from "./BurningMatters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports